import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { AuthenticationResult, EventMessage, EventType, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import '@progress/kendo-theme-bootstrap/dist/all.css';
import 'jquery/dist/jquery.min.js';
import React from 'react';
import { loginRequest } from '../../azure/authConfig';
import { msalInstance } from "../../index";
import { initilizeUserInfo } from '../../service/userService';

/**
 * Sandeep: Initilize user info and set the cache for the user by utilizing the received access token.
 * Loader types: ["pulsing", "infinite-spinner", "converging-spinner"];
 */
class DashboardWrapper extends React.Component {

    constructor(props: any) {
        super(props)
        this.state = {
            initilized: false,
            authorized: false,
            loaderRemove: false
        }

        msalInstance.addEventCallback((event: EventMessage) => {
            if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType == EventType.ACQUIRE_TOKEN_SUCCESS) && event.payload) {
                initilizeUserInfo(this.initRender);
            }
        });
    }

    /**
   * Sandeep: Callback method to render the UI after the token is received and set to cache.
   */
    initRender = (status: string) => {
        if (status == '200')
            this.setState({ initilized: true, authorized: true });
        else if (status == '401')
            this.setState({ authorized: false });
    }

    /**
     * State of the component
     */
    state = {
        initilized: false,
        authorized: false,
        loaderRemove: true
    }

    /**
     * Sandeep: Get and cache user information in local storage for UI use.
     * we are ensuring all keys to be encrypted while getting the information.
     */
    componentDidMount = async () => {
        //let msal = msalInstance;
        //if (msal.getAllAccounts().length > 0) {
        //    this.setState({ initilized: true });
        //} else {
        //    this.setState({ initilized: false });
        //}
    }

    /**
     * Render the UI.
     * @returns
     */
    render() {
        return (<>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest} >
                {
                    this.state.initilized ? this.props.children :
                        <div className="loaderWrapperB2C">
                            <div className="loading d-flex justify-content-center align-items-center">
                                <span className="loader3">Trailboss</span>
                            </div>
                        </div>
                }
            </MsalAuthenticationTemplate>
        </>)
    }
};
export default DashboardWrapper;
